module.exports = __webpack_public_path__ + "lazerSlide.webp?e799df5e44a11ed9ff7eebc82d185b42";